import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Typography, Container, Chip } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import CloudIcon from "@mui/icons-material/Cloud";
import ChatIcon from "@mui/icons-material/Chat";

import { ACTIONS as SEARCH_ACTIONS } from "../../../redux/search";
import { ACTIONS as CHAT_ACTIONS } from "../../../redux/chat";

import UserPicture from "../../../components/user-picture";
import ModalImage from "../../../components/modal-image";
import ImageList from "../../../components/image-list";

import NotFoundMessage from "../../../components/not-found-message";
import StyledSearchprofilePage from "./styles";
import { Button } from "@mui/material";

import { getUid } from "../../../api/auth";

const SearchProfilePage = ({ props }) => {
  const dispatch = useDispatch();
  const { uid } = useParams();
  const { profileInfo, api, init } = useSelector((state) => state.search);
  const { info, attachments } = profileInfo;

  const [modal, setModal] = useState({ open: false, props: {} });

  const onModalImageClose = () => {
    setModal({ open: false, props: {} });
  };

  const onImageModalOpen = (item) => {
    setModal({ open: true, props: item });
  };

  const onContactButtonHandler = () => {
    const { info } = profileInfo;

    dispatch(CHAT_ACTIONS.openChat({ ...info }));
  };

  useEffect(() => {
    dispatch(SEARCH_ACTIONS.getProfileInfo({ uid }));

    return () => dispatch(SEARCH_ACTIONS.clearProfileInfo());
  }, [dispatch, uid]);

  return (
    <StyledSearchprofilePage>
      <div className="profile-background-image">
        <img
          src={process.env.PUBLIC_URL + "/university.jpeg"}
          alt="biblioteca"
        />
      </div>

      <div className="search-profile-page">
        <Container maxWidth="md">
          <div className="search-profile-header">
            <div className="profile-picture">
              <UserPicture
                color="default"
                size={130}
                name={info?.name}
                surname={info?.surname}
                image={info?.profilePicture}
                loading={api.loading || !init}
              />
            </div>
            <div className="search-profile-container">
              <div className="search-profile-content">
                {info?.name && info?.surname && (
                  <Typography variant="h5">
                    {info.name} {info.surname}
                  </Typography>
                )}

                {info?.university && (
                  <div className="user-card-uni">
                    <SchoolIcon sx={{ width: 20, height: 20 }} />
                    <Typography variant="subtitle2">
                      {info.university}
                    </Typography>
                  </div>
                )}
              </div>
              <div className="search-profile-actions">
                <div>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<ChatIcon />}
                    onClick={onContactButtonHandler}
                  >
                    Contactar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="search-profile-main-info">
        <Container maxWidth="lg" className="search-profile-main-info-container">
          <div className="search-profile-main-i">
            <Typography variant="h6" sx={{ marginBottom: "0.5rem" }}>
              Información académica
            </Typography>

            <div className="search-profile-pill-cont">
              {info?.investigationGroup && (
                <div className="item-cont">
                  <div>
                    <Typography variant="subtitle2">
                      Grupos de investigación
                    </Typography>

                    <div className="pill-cont">
                      {info?.investigationGroup.map((e) => (
                        <Chip label={e} color="primary" size="small" />
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {info?.investigationLines && (
                <div className="item-cont">
                  <div>
                    <Typography variant="subtitle2">
                      Líneas de investigación
                    </Typography>

                    <div className="pill-cont">
                      {info?.investigationLines.map((e) => (
                        <Chip label={e} color="primary" size="small" />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="search-profile-files">
            <Typography variant="h6" sx={{ marginBottom: "0.5rem" }}>
              Archivos adjuntos
            </Typography>

            {attachments.length > 0 ? (
              <ImageList
                attachments={attachments}
                onImageClick={onImageModalOpen}
                maxHeight="300px"
                className="image-list"
              />
            ) : (
              <NotFoundMessage
                message="No hay archivos adjuntos"
                Icon={CloudIcon}
              />
            )}
          </div>
        </Container>
      </div>
      <ModalImage
        open={modal.open}
        onClose={onModalImageClose}
        {...modal.props}
      />
    </StyledSearchprofilePage>
  );
};

export default SearchProfilePage;
